import { useRouter } from 'next/router';
import { ReactNode } from 'react';

const GuardLoaderComponent = ({ children }: { children: ReactNode }) => {
  const router = useRouter();

  const hiddenPaths = ['/employer/job-positions/onboarding', '/getting-started'];

  if (hiddenPaths.includes(router.pathname)) return null;

  return <>{children}</>;
};

export default GuardLoaderComponent;
